import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import css from "./cpSourcingMobile.module.css";

// Applied selections, each removable. Removing one applies immediately — the
// call site drops the id from *both* pending and applied state, so reopening
// the sheet shows exactly what these chips show.
export default function ActiveFilterChips({ chips = [], onRemove }) {
  if (chips.length === 0) return null;

  return (
    <div className={css.chips}>
      {chips.map((chip) => (
        <button
          key={chip.id}
          type="button"
          className={css.chip}
          aria-label={`Remove filter ${chip.label}`}
          onClick={() => onRemove(chip.id)}
        >
          {chip.label}
          <CloseIcon sx={{ fontSize: 16, color: "#667085" }} />
        </button>
      ))}
    </div>
  );
}
